import React, { useEffect, useState } from 'react';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Worker } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';

type Props = {
  pdfBlob?: Blob
}

const PdfViewer: React.FC<Props> = (props) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const zoomPluginInstance = zoomPlugin();
  const { zoomTo } = zoomPluginInstance;

  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchPdf = async () => {
      if (props?.pdfBlob) {
        const url = URL.createObjectURL(props.pdfBlob);
        
        //console.log(props.pdfBlob);
        setPdfUrl(url);
      }
    };

    fetchPdf();

    // Pulizia dell'URL quando il componente viene smontato
    // return () => {
    //   if (pdfUrl) {
    //     URL.revokeObjectURL(pdfUrl);
    //   }
    // };
  }, [props]); // Aggiungi pdfUrl come dipendenza per gestire l'aggiornamento

  React.useEffect(() => {
    if (zoomTo) {
        // Calcola lo zoom per adattare la pagina alla larghezza del contenitore
        const containerWidth = window.innerWidth; // Larghezza del contenitore
        const pageWidth = 800; // Larghezza stimata della pagina PDF (personalizzabile)
        const fullPageZoom = containerWidth / pageWidth;

        zoomTo(fullPageZoom);
    }
}, [zoomTo]);

  return (
    <Worker workerUrl="\pdfjs\pdf.worker.js">
      {pdfUrl && 
      <Viewer
        fileUrl={pdfUrl} // Percorso del PDF
        plugins={[defaultLayoutPluginInstance,zoomPluginInstance]} // Aggiunge funzionalità di layout
      />
}
    </Worker>
  );
};

export default PdfViewer;
